<template>
    <el-drawer
        title="上传海报"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
		:modal="false"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"                
                ref="formData"               
            >				
				
                <el-form-item prop="photo" label="大麦专属演出海报:">
					<div class="form-flex">						
						<image-upload
						    :url.sync="formData.poster" 
						    :urlFull.sync="formData.poster" 
						    :original.sync="formData.posterOriginal"
							:maxWidth="1020"
							:maxHeight="1360"
							:bytes="3"
							
						>
						    <span slot="size">不超过1020px*1360px</span>
						    <span slot="tips">不可带有二维码和LOGO</span>
						</image-upload>
					</div>				    
				</el-form-item>   
                         
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" 
				:loading="btnLoading"
				@click="submitForm"
             >确定</el-button
            >
        </div> 
    </el-drawer>
</template>

<script>

import ImageUpload from '@/components/ImageUpload';
const defaultFormData = {
    poster: "",    
}
export default {
    components:{ ImageUpload},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData:{
				...defaultFormData
			},           
            id:'',	
			data:{
				
			}
			
		}
    },
   
    methods:{
        
        close() {            
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.drawerShow = false;
        },
        show(data) {			
           this.data = data;
		   if( this.data.poster ){
			   this.formData.poster = this.data.poster
		   }else{
			   this.formData.poster = ''
		   }
           this.drawerShow = true;
        },
		submitForm() {
		   let self = this;		   
		   self.$refs["formData"].validate((valid) => {
		       if (valid && this.formData.poster) {
				this.$set(this.data, 'poster', this.formData.poster);
				console.log(this.data)
				this.drawerShow = false;
		       } else {
		           return false;
		       }
		   });
		           
		},
        
    }
}
</script>

<style lang="scss" scoped>
.form-flex{
    width: 100%;
    overflow: hidden;
}
</style>